module.exports = __webpack_public_path__ + "static/media/heavy_pound51.d82d0a34.jpg";